import { render, staticRenderFns } from "./NewRequestDialog.vue?vue&type=template&id=570d2856"
import script from "./NewRequestDialog.vue?vue&type=script&lang=js"
export * from "./NewRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./NewRequestDialog.vue?vue&type=style&index=0&id=570d2856&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports